.moreResultsLink {
  display: flex;
  justify-content: center;
  padding: 5px 0;

  a {
    text-decoration: underline;
    font: var(--font-body-sm-semibold);
    color: var(--primitives-colors-neutral-0);
    text-transform: capitalize;
  }
}